export default __webpack_public_path__ + "static/media/DMSans-Light.b82ffc23.ttf";